module.exports = __webpack_public_path__ + "img/eb007ba.png";